import PropTypes from "prop-types";

export const geoProps = {
  handleMap: PropTypes.func.isRequired,
};
